import { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { TestesCustomModel } from '../../../../domain/models'
import {
  fetchModelTestes,
  resetTestes,
  saveTesteModel,
  updateTesteModel
} from '../../../../main/usecases'

import {
  Button,
  SubHeader,
  EditorCard,
  Loading,
  ServicesHeader
} from '../../../components'

import { formatDate, goToUrl } from '../../../utils'
import { useModalBox, useOnChangeDetect } from '../../../contexts'

import { IconSaveSvg, IconReturnSvg } from '../../../assets/icons/svgComponents'

import * as S from './styles'

const Teste = () => {
  const [teste, setTeste] = useState<TestesCustomModel[]>([])
  const [testeText, setTesteText] = useState('')
  const [htmlList, setHtmlList] = useState<any>({})
  const alert = useAlert()
  const location: any = useLocation()
  const history = useHistory()
  const { modalBox, modalClose } = useModalBox()
  const { refresh, setRefresh } = useOnChangeDetect()

  const handleOpenResetModal = () => {
    modalBox(
      <div className="delete-modal">
        <p className="attention-label">
          ATENÇÃO: Todas as edições serão perdidas
        </p>
        <p>Deseja realmente resetar o teste?</p>
        <div>
          <Button
            hasredButton
            onClick={() =>
              handleResetTeste(
                location.state.cdTypeToService || null,
                location.state.cdTeste || null
              )
            }
          >
            Sim
          </Button>
          <Button hasSecodaryButton onClick={modalClose}>
            Não
          </Button>
        </div>
      </div>,
      'Resetar Teste',
      '32%'
    )
  }

  const handleResetTeste = async (
    cdTypeToService: number | null,
    cdTeste: number | null
  ) => {
    try {
      if (cdTypeToService && cdTeste) {
        const responseToReset = await resetTestes({
          cdTypeToService: cdTypeToService,
          cdTeste: cdTeste
        }).load()
        modalClose(true)
        alert.show('Teste resetado com sucesso', {
          type: 'success',
          timeout: 4000
        })
        setTeste(responseToReset)
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
      alert.show('Erro ao resetar um Teste', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  useEffect(() => {
    if (teste) {
      const texts = teste?.map((item) => item?.texto)
      setHtmlList(texts)
    }
  }, [teste, refresh])

  useEffect(() => {
    ;(async () => {
      try {
        if (!location?.state) goToUrl(history, '/testes')

        const data = await fetchModelTestes({
          cdTeste: location?.state?.cdTeste,
          cdTypeToService: location?.state?.cdTypeToService
        }).load()
        setTeste(data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [
    history,
    location?.state,
    location?.state?.teste,
    location?.state?.cdTypeToService
  ])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = teste?.map((item, index) => {
      return {
        ...(item?.modeloAdm === false && {
          cdTesteResultado: item?.cdTesteResultado
        }),
        classificacao: item.classificacao,
        texto: htmlList[index] || testeText
      }
    })

    try {
      if (teste && teste[0]?.modeloAdm) {
        const responseToPost = await saveTesteModel({
          cdTeste: location.state.cdTeste,
          cdTypeToService: location.state.cdTypeToService
        }).post(body)
        alert.show('Salvo com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setTeste(responseToPost)
        setRefresh((prev: any) => !prev)
      } else {
        const responseToPut = await updateTesteModel().update(body)
        alert.show('Atualizado com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setTeste(responseToPut)
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      alert.show('Error ao salvar/atualizar', {
        type: 'error',
        timeout: 4000
      })
      console.error(error)
    }
  }

  if (!document) return <Loading />
  return (
    <S.Wrapper>
      <SubHeader page="Voltar" link={`/testes`} />
      <S.CardContainer>
        <ServicesHeader
          onClick={onSubmit}
          hasReset
          onReset={handleOpenResetModal}
          title={
            `${location?.state?.testeTitle || location?.state?.testTitle} | ${
              location?.state?.serviceTitle
            }` || ''
          }
        />
        {teste.map((item, index) => (
          <EditorCard
            data={item && item?.texto}
            setData={setTesteText}
            title={item && `${item.classificacao} | ${item?.teste.nome}`}
            onChangeContentToEditor={(html) => {
              setTesteText((prev: any) => ({
                ...prev,
                [index]: html
              }))
              setHtmlList((prev: any) => ({
                ...prev,
                [index]: html
              }))
            }}
          />
        ))}
        {teste.length ? (
          <S.ButtonsContainer>
            <Button
              initialIcon={<IconSaveSvg />}
              className="button-save"
              onClick={onSubmit}
            >
              Salvar
            </Button>
            <Button
              initialIcon={<IconReturnSvg />}
              hasSecodaryButton
              className="button-return-to-list"
            >
              <Link to={`/testes`}>Retornar à listagem</Link>
            </Button>

            {teste[0]?.dataUltimaModificacao && (
              <p>
                Data da última atualização:{' '}
                {formatDate(teste[0]?.dataUltimaModificacao || '2022-05-05')}
              </p>
            )}
          </S.ButtonsContainer>
        ) : (
          ''
        )}
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Teste
